import * as React from 'react';

import { type PaginationState } from '@tanstack/react-table';
import { useSearchParams } from 'react-router-dom';

import { useTableStore } from 'src/stores/useTableStore';
import { tableStorage } from 'src/utils/storage';

export const pageSizes = {
    10: 10,
    25: 25,
    50: 50,
    100: 100,
};

type UsePaginationProps = {
    pageIndex?: number;
    pageSize?: keyof typeof pageSizes;
};

function usePagination(props?: UsePaginationProps) {
    const [searchParams] = useSearchParams();
    const { name } = useTableStore();
    const [paginationState, setPaginationState] = React.useState<PaginationState>(() => {
        const searchParamsPage =
            searchParams.get('page') != null ? parseInt(searchParams.get('page') || '', 10) : undefined;
        const searchParamsSize =
            searchParams.get('size') != null ? parseInt(searchParams.get('size') || '', 10) : undefined;

        const tableStorageState = tableStorage.getTableState(name || '') || {};
        const pageIndex = searchParamsPage ?? tableStorageState.pageIndex ?? props?.pageIndex ?? 0;
        const pageSize = searchParamsSize ?? tableStorageState.pageSize ?? props?.pageSize ?? 25;

        return { pageIndex, pageSize };
    });

    const queryPaginationOptions = React.useMemo(() => {
        return {
            limit: paginationState.pageSize,
            offset: paginationState.pageIndex * paginationState.pageSize,
        };
    }, [paginationState, name]);

    return { paginationState, setPaginationState, queryPaginationOptions };
}

export default usePagination;
